import React from 'react';
import './jds.css';

const TAG_COLORS = {
  neutral: ['var(--bg-neutral-layer03)', 'var(--fg-neutral-default)'],
  brand: ['var(--bg-brand-subtler)', 'var(--fg-brand-stronger)'],
  success: ['var(--bg-success-subtler)', 'var(--fg-success-strong)'],
  error: ['var(--bg-error-subtler)', 'var(--fg-error-strong)'],
  info: ['var(--bg-info-subtler)', 'var(--fg-info-strong)'],
  warning: ['var(--bg-warning-subtler)', 'var(--fg-warning-stronger)'],
};

// Tag do Jusfy DS (tipo label, ou label-icon com `dot`). Leva a própria
// .jds-scope para resolver os tokens também em listagens fora do escopo.
export function JdsTag({ label, color = 'neutral', dot = false }) {
  const [background, foreground] = TAG_COLORS[color];

  return (
    <span
      className="jds-scope"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--space-4)',
        height: 24,
        padding: '0 var(--space-8)',
        borderRadius: 'var(--radius-small)',
        background,
        color: foreground,
        fontSize: 'var(--fs-14)',
        whiteSpace: 'nowrap',
      }}
    >
      {dot && (
        <span
          aria-hidden="true"
          style={{
            width: 6,
            height: 6,
            borderRadius: 'var(--radius-full)',
            background: foreground,
          }}
        />
      )}
      {label}
    </span>
  );
}
